/**
 * ChangelogFilters — event type and date range filter controls.
 */

import { Box, Flex, Select, Text, TextField } from "@radix-ui/themes";

const EVENT_TYPES = [
  { value: "__all__", label: "All events" },
  { value: "parameter_changed", label: "Parameter changed" },
  { value: "staleness_propagated", label: "Staleness propagated" },
  { value: "staleness_cleared", label: "Staleness cleared" },
  { value: "data_imported", label: "Data imported" },
  { value: "runs_created", label: "Runs created" },
  { value: "wing_area_detected", label: "Wing area detected" },
  { value: "wing_area_confirmed", label: "Wing area confirmed" },
  { value: "branch_merged", label: "Branch merged" },
  { value: "commit_created", label: "Commit created" },
];

interface Props {
  eventType: string;
  onEventTypeChange: (type: string) => void;
  since: string;
  onSinceChange: (val: string) => void;
  until: string;
  onUntilChange: (val: string) => void;
}

export function ChangelogFilters({
  eventType,
  onEventTypeChange,
  since,
  onSinceChange,
  until,
  onUntilChange,
}: Props) {
  return (
    <Flex gap="3" align="end" wrap="wrap">
      <Box>
        <Text size="1" color="gray" mb="1" as="label">
          Event type
        </Text>
        <Select.Root value={eventType} onValueChange={onEventTypeChange}>
          <Select.Trigger />
          <Select.Content>
            {EVENT_TYPES.map((t) => (
              <Select.Item key={t.value} value={t.value}>
                {t.label}
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Root>
      </Box>

      <Box>
        <Text size="1" color="gray" mb="1" as="label">
          Since
        </Text>
        <TextField.Root
          type="date"
          size="2"
          value={since}
          onChange={(e) => onSinceChange(e.target.value)}
        />
      </Box>

      <Box>
        <Text size="1" color="gray" mb="1" as="label">
          Until
        </Text>
        <TextField.Root
          type="date"
          size="2"
          value={until}
          onChange={(e) => onUntilChange(e.target.value)}
        />
      </Box>
    </Flex>
  );
}
